import React from 'react';
import Banner from '../components/Banner';
import Hero from '../components/Hero';
import CertificationServices from '../components/CertificationServices';
import OurPractices from '../components/OurPractices';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <>
      <Banner />
      <Hero />
      <CertificationServices />
      <OurPractices />
      <Newsletter />
    </>
  );
};

export default Home;

